export default "__VITE_ASSET__Ze2lf2NW__"